// UserSearch.jsx
import React, { useState } from 'react';
import styles from './UserSearchGeneric.module.css';
import { HiMiniMagnifyingGlass, HiXMark } from 'react-icons/hi2';
import { useAuth } from "./../AuthContext/authcontext";
import avatar from './../../assets/default-avatar.svg';
import Button from '../../components/ui/Button';

export default function UserSearchGeneric({cache, currentUser, setCache, onSelect, onCancel, singleSearch = false}) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const {searchUsers} = useAuth();
  
  const handleSearch = async () => {
	if(query.length < 1) return;	
	    	
	if (cache[query]?.length > 0) {
      setResults(cache[query]);
      return;
    }

    try {
	  const fetched = await searchUsers(query);
	  setCache(prev => ({ ...prev, [query]: fetched }));
	  setResults(fetched);
    } catch (err) {
      console.error(err);
    }
  };
  
  const handleCancel = async () => {
	if(singleSearch == true) setResults([]);
	onCancel();
  };

  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchRow}>
        <input
          type="text"
          placeholder="Search username/email..."
          value={query}
          onChange={e => setQuery(e.target.value)}
        />
        <Button onClick={handleSearch}><HiMiniMagnifyingGlass /></Button>
        <Button onClick={handleCancel}>Cancel</Button>
      </div>
      <div className={styles.results}>
        {singleSearch == false ? <div key={currentUser.uid} className={styles.result} onClick={() => onSelect(currentUser)}>
		  <img src={currentUser.profilePicture || avatar} className={styles.icon} alt="" />
          <span>You: {currentUser.username} ({currentUser.email})</span>
          </div> : <></>}
        {results.map(u => (
          <div key={u.uid} className={styles.result} onClick={() => onSelect(u)}>
		  <img src={u.profilePicture || avatar} className={styles.icon} alt="" />
          <span>{u.username} ({u.email})</span>
          </div>
        ))}
        {results.length === 0 && singleSearch == false && <p className={styles.noResults}>No results</p>}
      </div>
    </div>
  );
}
